import tunnel from "tunnel-rat";

export const planogramInfoTunnel = tunnel();
